import { TextInputField, TTextInputFieldProps } from '../../../forms';

// import './style.css';

export interface IFormField extends TTextInputFieldProps {
  id: string;
}

interface IFormFieldsProps {
  fields: IFormField[];
}

/**
 * -----------------------------------------------------------------------------
 * It renders the form field with inputs
 */
export function FormFields({ fields }: Readonly<IFormFieldsProps>) {
  return (
    <div
      className="
        form-fields grid grid-cols-1 gap-x-3 gap-y-2 pb-4 sm:grid-cols-2
      "
    >
      {fields.map((item) => (
        <div key={item.id}>
          <TextInputField {...item} />
        </div>
      ))}
    </div>
  );
}
